import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot,} from '@angular/router';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
class AuthGuardService {

  constructor(private readonly router: Router,private readonly authService:AuthService) {}

 async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):Promise<boolean> {
    if(await this.authService.isLoggedIn()){
      return true;
    }
    this.router.navigate(['/auth/login']);
    return false;
  }
}

export const AuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot):Promise<boolean> => {
  return inject(AuthGuardService).canActivate(next, state);
}






